import { render, staticRenderFns } from "./frameDataV.vue?vue&type=template&id=22021e94&scoped=true&"
import script from "./frameDataV.vue?vue&type=script&lang=js&"
export * from "./frameDataV.vue?vue&type=script&lang=js&"
import style0 from "./frameDataV.vue?vue&type=style&index=0&id=22021e94&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22021e94",
  null
  
)

export default component.exports